// personEvents.ts
export type PersonCreatedPayload = {
  id: string;
  label: string;
  mainBusinessPartnerId: string;
};

const EVENT = 'person:created';

export function publishPersonCreated(payload: PersonCreatedPayload) {
  window.dispatchEvent(
    new CustomEvent<PersonCreatedPayload>(EVENT, { detail: payload })
  );
}

export function onPersonCreated(
  handler: (p: PersonCreatedPayload) => void
): () => void {
  const listener = (e: Event) =>
    handler((e as CustomEvent<PersonCreatedPayload>).detail);
  window.addEventListener(EVENT, listener as EventListener);

  return () => window.removeEventListener(EVENT, listener as EventListener);
}
